import { Profile } from '@atlaskit/atlassian-navigation';
import Avatar from '@atlaskit/avatar';
import Popup from '@atlaskit/popup';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { AnalyticsConsumerProps, withAnalytics } from '../../../../hoc/withAnalytics';
import Store from '../../../../store';
import UIStore from '../../../../store/uiStore';
import UserStore from '../../../../store/userStore';
import { profileMessages as messages } from '../../../common/intl/profile';

import ProfileMenuContent from './ProfileMenuContent';

interface State {
  isOpen: boolean;
}

interface Props {
  uiStore: UIStore;
  userStore: UserStore;
}

type ComponentProps = Props & AnalyticsConsumerProps;

@observer
class NavProfileButton extends React.Component<ComponentProps, State> {
  state: State = {
    isOpen: false,
  };

  render() {
    const { isOpen } = this.state;
    return (
      <Popup
        placement="bottom-end"
        content={() => <ProfileMenuContent />}
        isOpen={isOpen}
        onClose={() => this.setIsOpen(false)}
        testId="nav__profile-menu"
        trigger={triggerProps => (
          <Profile
            testId="nav__profile-menu-trigger"
            isSelected={isOpen}
            icon={<Avatar borderColor="transparent" src={this.props.userStore.picture} size="small" />}
            onClick={() => this.setIsOpen(!isOpen)}
            tooltip={<FormattedMessage {...messages.profile} />}
            {...triggerProps}
          />
        )}
      />
    );
  }

  setIsOpen = (open: boolean) => {
    this.setState({ isOpen: open });
  };
}

export default inject(({ userStore, uiStore }: Store) => ({
  uiStore,
  userStore,
}))(withAnalytics(NavProfileButton));
